import { launchErrorDialog } from '../components/ErrorDialog';
import { IPresentationException } from '../interface';

// PAP - don't want to directly import phoenix or react into redux-saga context so this is an indirection
export function renderError(error: IPresentationException) {
  launchErrorDialog(error);
}
